import { Check, Lock } from "lucide-react";

const slotState = (available, selected) => {
  if (!available) return "booked";
  if (selected) return "selected";
  return "available";
};

export const SlotCard = ({ slot, available, selected, onSelect }) => {
  const state = slotState(available, selected);
  const styles = {
    available: "border-emerald-500/30 bg-emerald-950/20 hover:border-emerald-500 cursor-pointer",
    booked: "border-zinc-800 bg-zinc-900/50 cursor-not-allowed opacity-60",
    selected: "border-[#FF3333] bg-[#FF3333]/10 shadow-[0_0_20px_rgba(255,51,51,0.3)] scale-[1.02]",
  }[state];

  return (
    <button
      type="button"
      disabled={!available}
      onClick={() => onSelect(slot.id)}
      data-testid={`timeslot-${slot.id}`}
      data-state={state}
      className={`flex w-full items-center justify-between rounded-md border p-5 text-left transition-[border-color,background-color,transform,box-shadow] duration-200 ${styles}`}
    >
      <div>
        <p className={`font-display text-lg font-semibold uppercase ${available ? "text-white" : "text-zinc-500 line-through"}`}>{slot.label}</p>
        <p className="font-tech text-sm text-zinc-400">{slot.time}</p>
      </div>
      {state === "booked" && <span className="flex items-center gap-2 font-tech text-xs uppercase tracking-widest text-zinc-500"><Lock className="h-3.5 w-3.5" /> Booked</span>}
      {state === "available" && <span className="font-tech text-xs uppercase tracking-widest text-emerald-400">Open</span>}
      {state === "selected" && <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#FF3333]"><Check className="h-4 w-4 text-white" /></span>}
    </button>
  );
};
